module.exports = __webpack_public_path__ + "static/starter-4f8d2beedb3b8827c3a909b596fdc7ac.png";